<ngx-slick-carousel
  class="carousel carouselNewHome"
  #carouselNewHome="slick-carousel"
  [config]="slideConfig"
>
  @for (category of categories(); track category.id) { @for (subcategory of category.subcategories;
  track $index) {
  <div
    ngxSlickItem
    class="slide newCategoryHome"
    data-aos="fade-up"
    (click)="goToLink(category.slug, subcategory.slug)"
  >
    <div class="contentImage">
      <img [ngSrc]="subcategory.carousel_image" [alt]="subcategory.name" fill />
      <div class="poly"></div>
    </div>
    <a class="titleCategory" [routerLink]="'/productos/' + category.slug + '/' + subcategory.slug">
      <h3>{{ subcategory.name | uppercase }}</h3>
    </a>
    <div class="btnTracsa btnYellow">VER EQUIPOS</div>
  </div>
  } }
</ngx-slick-carousel>
